var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputSearch = function SvgInputSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#input-search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.692 7.568a6.875 6.875 0 1 1 13.751 0 6.875 6.875 0 0 1-13.75 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.274 13.274a.573.573 0 0 1 .81 0l3.056 3.056a.573.573 0 0 1-.81.81l-3.056-3.056a.573.573 0 0 1 0-.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.772 2.941a.573.573 0 0 1-.476.656 3.25 3.25 0 0 0-2.7 2.699.573.573 0 0 1-1.13-.18 4.39 4.39 0 0 1 3.65-3.65.573.573 0 0 1 .656.475",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "input-search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export { SvgInputSearch as ReactComponent };